export enum ExternalDealFilterSortFieldsEnum {
  PRICE = "price"
}

export const externalDealFilterSortFields: ExternalDealFilterSortFieldsEnum[] = [
  ExternalDealFilterSortFieldsEnum.PRICE
];
